import { Coins } from '@bonanza-social/moonlight';
import { addListener, useDispatch } from '@bonanza-social/toolkit/state';
import { coinBalanceWallet } from '@bonanza-social/wallet';
import { useEffect, useRef } from 'react';
import { View } from 'react-native';
import { dailyRewardCollected, DailyRewardType } from '../state';

const useDailyRewardCoinAnimation = (type: DailyRewardType) => {
  const widgetRef = useRef<View>(null);

  const targetElement = coinBalanceWallet.current;
  const widget = widgetRef.current;

  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        actionCreator: dailyRewardCollected,

        effect: ({ payload }) => {
          if (payload.rewardType !== 'Coins') {
            return;
          }

          if (widget && targetElement && type === payload.type) {
            widget.measureInWindow((wx, wy, wWidth) => {
              targetElement.measureInWindow((tx, ty, tWidth, tHeight) => {
                const entryX = wx + (wWidth || 0) / 2;
                const entryY = wy - 40;

                Coins.animate({
                  count: 40,
                  duration: 1500,
                  spawnRange: 100,
                  entryPoint: { x: entryX, y: entryY },
                  targetPoint: { x: tx + tWidth / 2, y: ty + tHeight / 2 },
                });
              });
            });
          }
        },
      }),
    );

    return unsubscribe;
  }, [dispatch, targetElement, widget, type]);

  return { widgetRef };
};

export default useDailyRewardCoinAnimation;
